"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createFontFamily = function createFontFamily(fonts) {
  return fonts.map(function (font) {
    return "\"".concat(font, "\"");
  }).join(', ');
};

var _default = createFontFamily;
exports["default"] = _default;